import { SEASON_STATS } from '../data/mockData';

export default function History() {
  const s = SEASON_STATS;

  return (
    <div style={{ padding: '20px 20px 24px' }}>

      {/* header */}
      <div style={{ marginBottom: 20 }}>
        <div style={{
          fontSize: '0.62rem', fontWeight: 700,
          letterSpacing: 3, textTransform: 'uppercase',
          color: '#8090B0', marginBottom: 6,
        }}>
          Season 2026
        </div>
        <div style={{
          fontSize: '1.7rem', fontWeight: 800, letterSpacing: '-0.3px',
        }}>
          Model <span style={{ color: '#D42B2B' }}>History</span>
        </div>
      </div>

      {/* season stat grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: 10,
        marginBottom: 24,
      }}>
        {[
          { val: s.played,         lbl: 'Games Played', red: false, green: false },
          { val: `${s.rate}%`,     lbl: 'No-HR Rate',   red: true,  green: false },
          { val: `${s.accuracy}%`, lbl: 'Accuracy',     red: false, green: true  },
          { val: s.noHR,           lbl: 'No-HR Games',  red: true,  green: false },
          { val: s.streak,         lbl: 'Day Streak',   red: false, green: false },
          { val: s.pl,             lbl: 'Season P/L',   red: false, green: true  },
        ].map(item => (
          <div key={item.lbl} style={{
            background: '#F5F6FA',
            borderRadius: 10,
            padding: '12px 10px',
            textAlign: 'center',
          }}>
            <div style={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontSize: '1.6rem', lineHeight: 1,
              color: item.red ? '#D42B2B' : item.green ? '#15803D' : '#0A1740',
            }}>
              {item.val}
            </div>
            <div style={{
              fontSize: '0.58rem', fontWeight: 600,
              color: '#8090B0', textTransform: 'uppercase',
              letterSpacing: 1, marginTop: 3,
            }}>
              {item.lbl}
            </div>
          </div>
        ))}
      </div>

      {/* coming soon */}
      <div style={{
        fontSize: '0.62rem', fontWeight: 700,
        letterSpacing: 2, textTransform: 'uppercase',
        color: '#8090B0', marginBottom: 12,
      }}>
        Recent Results
      </div>

      <div style={{
        background: '#F5F6FA',
        borderRadius: 12,
        padding: '32px 20px',
        textAlign: 'center',
      }}>
        <div style={{
          fontSize: '2rem',
          marginBottom: 10,
        }}>
          📋
        </div>
        <div style={{
          fontSize: '0.88rem',
          fontWeight: 700,
          color: '#0A1740',
          marginBottom: 6,
        }}>
          Results tracking coming soon
        </div>
        <div style={{
          fontSize: '0.75rem',
          color: '#8090B0',
          lineHeight: 1.55,
        }}>
          Daily outcomes will be logged here automatically after each game.
          Check back tomorrow for today's results.
        </div>
      </div>

    </div>
  );
}
